<app-esqueleto-tableros>
	<div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
	<app-filters filtros 
		[name]="'filtros.per' | translate"
		[array]="aniosDisponibles"
		[typeFilter]="Filters.PERIOD"
		(eventClick)="anioChange($event)">
	</app-filters>

	<app-filters filtros
    [name]="'filtros.pers' | translate" 
    [array]="perspectives"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="todasPer"
    (eventClick)="persChange($event);"
  />
	<div borrador [ngStyle]="{'color':'gray'}" class="iconoMen"
    (click)="borrarFiltros()" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
    <img src="./../../../../assets/img/eraser.png">
  </div>

	<div class="contenido" contenido>
		@if (viewTablero) {
			<div class="zonaEncabezadosCMI">
				<div class="w3-noventa2">
					<div class="filosofiaCMI tarjetaInformativa">
						<div class="headerTarjetaInformativa w3-titulo-contenidomenuSC">
							<div class="tituloTarjetaIzquierdo hijoizquierdaTitle">
								@if (!acum) {
									<span class="w3-margin-left-contenido textoZon">{{
										'gestion.seguimiento.cmi.avance' | translate }} |
										{{escrituraPeriodo(perSelected())}}</span>
								}
								@if (acum) {
									<span class="w3-margin-left-contenido textoZon">{{
										'gestion.seguimiento.cmi.avanceGen' | translate }}</span>
								}
							</div>
							<div class="tituloTarjetaDerecho">
								<mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
									[matMenuTriggerFor]="tiposAvance">more_vert</mat-icon>
								<mat-menu #tiposAvance="matMenu">
									@if (!acum) {
										<button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="changeAvance()">
											{{ 'gestion.seguimiento.cmi.avanceGen' | translate }}
										</button>
									}
									@if (acum) {
										<button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="changeAvance()">
											{{ 'gestion.seguimiento.cmi.avance' | translate }} |
											{{escrituraPeriodo(perSelected())}}
										</button>
									}
								</mat-menu>
							</div>
						</div>
						<div class="bodyTarjetaInformativa">
							<span class="cifraPrin">{{avancePlan}}
								@if (avancePlan!==null) {
									<span>%</span>
								}
							</span>
						</div>
					</div>
					@if (mision !== undefined) {
						<div class="filosofiaCMI">
							<div class="w3-row tituloFilosofiaCMI">{{mision.name}}:</div>
							<div class="w3-row contenidoFilosofiaCMI" matTooltipPosition="right" matTooltip="{{mision.description}}">
								<span>{{mision.description}}</span>
							</div>
						</div>
					}
					@if (vision !== undefined) {
						<div class="filosofiaCMI">
							<div class="w3-row tituloFilosofiaCMI">{{vision.name}}:</div>
							<div class="w3-row contenidoFilosofiaCMI" matTooltipPosition="right" matTooltip="{{vision.description}}">
								<span>{{vision.description}}</span>
							</div>
						</div>
					}
				</div>
				<div class="w3-rest">
					<div class="w3-right">
						<mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
							[matMenuTriggerFor]="menutabla">more_vert</mat-icon>
						<mat-menu #menutabla="matMenu">
							@if (tarjOrTab) {
								<button (click)="exportarImge('tarjetasTod', 'tot')" class="mat-menu-item" mat-menu-item
									class="w3-caja-menu">
									<mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
									<span>{{ 'gestion.seguimiento.cmi.expor' | translate }}</span>
								</button>
							}
							@if (!tarjOrTab) {
								<button (click)="exportarExcelTab()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
									<mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
									<span>{{ 'gestion.seguimiento.cmi.expor' | translate }}</span>
								</button>
							}
							<button (click)="cambioTarjTab()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
								@if (tarjOrTab) {
									<mat-icon [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
								}
								@if (!tarjOrTab) {
									<mat-icon [ngStyle]="{'color':'gray'}">crop_landscape</mat-icon>
								}
								@if (tarjOrTab) {
									<span>{{ 'gestion.seguimiento.cmi.table' | translate }}</span>
								}
								@if (!tarjOrTab) {
									<span>{{ 'gestion.seguimiento.cmi.tarje' | translate }}</span>
								}
							</button>
						</mat-menu>
					</div>
				</div>
			</div>
			<div class="zonaTarjetasCMI">
				@if (tarjOrTab) {
					@for (per of diccionarioPer; track per) {
						@if (mostrarPers(per)) {
							<div class="w3-row contenerdorObj" id="{{'graf'+per.perspective.name}}">
								<div class="titulo">
									<div class="w3-noventa2 w3-titulo-contenidomenuSC padreizquierda">
										<div class="hijoizquierdaTitle">
											<span class="w3-margin-left-contenido w3-tituloZonas">{{per.perspective.name}}</span>
										</div>
									</div>
									<div class="w3-rest">
									</div>
								</div>
								<div class="contenedorN">
									@for (obj of per.objetivos; track obj) {
										<div class="zoneNewTarjets">
											<div class="zone1T" [ngClass]="pintarBorde(obj.avance)" matTooltipPosition="right" matTooltipShowDelay="1000"
												matTooltip="{{obj.name}}">
												<div class="textoNombre">
													{{obj.name}}
												</div>
												<div class="iconoT">
													<mat-icon (click)="modalInd(obj)" class="iconoTarjCMI" style="overflow: visible;">info_outline</mat-icon>
												</div>
											</div>
											<div class="zone2T">
												@if (obj.avance !== undefined) {
													<div class="zonaTexto">
														<div [ngClass]="texto(obj.avance)" class="textoNumero">
															{{obj.avance}}%
														</div>
													</div>
												}
												@if (obj.avance === undefined) {
													<div class="zonaTexto">
														<div [ngClass]="texto(obj.avance)" class="textoNumero">
														</div>
													</div>
												}
												@if (obj.avance === undefined) {
													<div class="iconoInformacion">
														<mat-icon (click)="modalInfo(0)" class="iconoTarjCMI" style="overflow: visible;">info_outline</mat-icon>
													</div>
												}
											</div>
										</div>
									}
								</div>
							</div>
						}
					}
				}
				@if (!tarjOrTab) {
					<div class="w3-row contenedorTable2">
						<div class="tablaCont">
							<table class="w3-table allbordes">
								<thead>
									<tr class="w3-table-title">
										<th class="w3-border-right-balance w3-center enSticky">{{ 'gestion.seguimiento.cmi.persp'
											| translate }}</th>
										<th class="w3-border-right-balance w3-center enSticky">
											<table class="w3-table allbordes">
												<th class="" style="width: 1vw !important;">
													@if (!expandirObj) {
														<mat-icon (click)="oculMostAll()" class="w3-margin-right-contenido w3-button"
															[ngStyle]="{'color':'gray'}">expand_more</mat-icon>
													}
													@if (expandirObj) {
														<mat-icon (click)="oculMostAll()" class="w3-margin-right-contenido w3-button"
															[ngStyle]="{'color':'gray'}">expand_less</mat-icon>
													}
												</th>
												<th class="textoOverFlow">
													{{ 'gestion.seguimiento.cmi.objec' | translate }} / <span style="font-weight: lighter;">{{
														'gestion.seguimiento.cmi.indic' | translate
														}}</span>
												</th>
											</table>
										</th>
										<th class="w3-border-right-balance w3-center enSticky ponderaciones">{{
											'gestion.seguimiento.cmi.avanc' | translate }}</th>
									</tr>
								</thead>
								<tbody class="allBordes">
									@for (per of diccionarioPer; track per) {
										@for (obj of per.objetivos; track obj; let i = $index) {
											@if (per.perspective.check) {
												<tr class="w3-table-trtd">
													@if (i === 0) {
														<td class="w3-table-trtdBalance borderSup">
															{{per.perspective.name}}</td>
													}
													@if (i !== 0) {
														<td class="w3-table-trtdBalance"></td>
													}
													<td [ngClass]="pintarBordes(i)" class="borderAllLow marginIzq">
														<table class="w3-table allbordes">
															<td class="" style="width: 1vw !important;">
																@if (!obj.check) {
																	<mat-icon (click)="oculMost(obj)" class="w3-margin-right-contenido w3-button"
																		[ngStyle]="{'color':'gray'}">expand_more</mat-icon>
																}
																@if (obj.check) {
																	<mat-icon (click)="oculMost(obj)" class="w3-margin-right-contenido w3-button"
																		[ngStyle]="{'color':'gray'}">expand_less</mat-icon>
																}
															</td>
															<td class="textoOverFlow">
																<strong>{{obj.name}}</strong>
															</td>
														</table>
													</td>
													@if (obj.avance !== undefined) {
														<td [ngClass]="pintarBorde(obj.avance)" class="borderAllLow marginIzq alinCenter">
															<strong>{{obj.avance}} %</strong>
														</td>
													}
													@if (obj.avance === undefined) {
														<td [ngClass]="pintarBorde(obj.avance)" class="borderAllLow marginIzq alinCenter"></td>
													}
												</tr>
												@for (ind of obj.indicadores; track ind) {
													@if (obj.check) {
														<tr class="w3-table-trtd">
															<td class="w3-table-trtdBalance"></td>
															<td class="w3-table-trtdBalance borderIzq">
																<table class="w3-table">
																	<td class="borderLowInf" style="width: 1vw !important;">
																		@if (verCodigo) {
																			<span>Código</span>
																		}
																		@if (!verCodigo) {
																			<mat-icon class="w3-margin-right-contenido" [ngStyle]="{'color':'white'}">expand_less</mat-icon>
																		}
																	</td>
																	<td class="borderLowInf textoOverFlow">
																		{{ind.nombre}}
																	</td>
																</table>
															</td>
															@if (ind.avance !== undefined) {
																<td [ngClass]="pintarBorde(ind.avance)" class="w3-table-trtdBalance alinCenter borderLowInf">
																{{ind.avance}} %</td>
															}
															@if (ind.avance === undefined) {
																<td [ngClass]="pintarBorde(ind.avance)" class="w3-table-trtdBalance borderLowInf"></td>
															}
														</tr>
													}
												}
											}
										}
									}
								</tbody>
							</table>
						</div>
					</div>
				}
			</div>
		<!-- <div class="w3-row contenerdorObj mantenerFija borderTest" id="principal">
			
		</div> -->
		}@else {
		<div class="w3-row" style="height: 15vh; width: 98%;">
			<ngx-skeleton-loader count="3" [theme]="{
				'border-radius': '10px',
				height: '90%',
				width: '28%',
				margin: '4px 4px 4px 25px',
			}" />
		</div>
		<div class="w3-row" style="height: 65vh; width: 98%;">
			@for (item of tarjets; track $index) {
			<ngx-skeleton-loader [theme]="{
				'border-radius': '10px',
				height: '15px',
				width: '28%',
				margin: '25px 4px 4px 25px',
			}" />
			<br>
			<div class="w3-row w3-quarter" style="height: 20%;">
				<div class="w3-row w3-twothird" style="height: 100%;">
					<ngx-skeleton-loader [theme]="{
						'border-radius': '10px',
						height: '90%',
						width: '90%',
						margin: '4px 4px 4px 25px',                 
					}" />
				</div>
				<div class="w3-row w3-rest" style="height: 100%;">
					<ngx-skeleton-loader [theme]="{
					'border-radius': '10px',
					height: '90%',
					width: '98%',
					margin: '4px 4px 4px 4px',
				}" />
				</div>
			</div>
			<div class="w3-row w3-quarter" style="height: 20%;">
				<div class="w3-row w3-twothird" style="height: 100%;">
					<ngx-skeleton-loader [theme]="{
						'border-radius': '10px',
						height: '90%',
						width: '90%',
						margin: '4px 4px 4px 25px',
					}" />
				</div>
				<div class="w3-row w3-rest" style="height: 100%;">
					<ngx-skeleton-loader [theme]="{
						'border-radius': '10px',
						height: '90%',
						width: '98%',
						margin: '4px 4px 4px 4px',
					}" />
				</div>
			</div>
			<div class="w3-row w3-quarter" style="height: 20%;">
				<div class="w3-row w3-twothird" style="height: 100%;">
					<ngx-skeleton-loader [theme]="{
						'border-radius': '10px',
						height: '90%',
						width: '90%',
						margin: '4px 4px 4px 25px',
					}" />
				</div>
				<div class="w3-row w3-rest" style="height: 100%;">
					<ngx-skeleton-loader [theme]="{
						'border-radius': '10px',
						height: '90%',
						width: '98%',
						margin: '4px 4px 4px 4px',
					}" />
				</div>
			</div>
			}
		</div>
		}
	</div>

</app-esqueleto-tableros>